<section class="container-fluid sts-section">

  <app-sts-section-header *ngIf="!changeUserId" key="sts-signup-step-2-header" [errors]="errors">
    Pick username
    <app-sts-section-header-side>
      <div class="text-right"><a
        routerLink="/account/help" app-sts-cms-txt key="sts-need-help">Need help?</a>
      </div>
    </app-sts-section-header-side>
  </app-sts-section-header>

  <app-sts-section-header *ngIf="changeUserId" key="sts-change-login-username" [errors]="errors">
    enter a Unique User ID
    <app-sts-section-header-side>
      <div class="text-right"><a
        routerLink="/account/help" app-sts-cms-txt key="sts-need-help">Need help?</a>
      </div>
    </app-sts-section-header-side>
  </app-sts-section-header>

  <app-sts-section-body *ngIf="message.AllowUsernameAsUniqueId && !emailOnFileReadOnly" key="sts-registration-step-2-body-section">
    <!-- content is served by CMS -->
  </app-sts-section-body>

  <app-sts-section-body *ngIf="message.AllowUsernameAsUniqueId && emailOnFileReadOnly" key="sts-registration-step-2-body-section-email-readonly">
    <!-- content is served by CMS — variant for when email on file cannot be changed -->
  </app-sts-section-body>

  <app-sts-section-body *ngIf="!message.AllowUsernameAsUniqueId" key="sts-registration-step-2-body-section-disallow-username">
    <!-- content is served by CMS -->
  </app-sts-section-body>


  <form #form="ngForm" (ngSubmit)="onSubmit()"
        [formGroup]="signUpForm"
        class="sts-form" autocomplete="off">

    <div class="row sts-form-row">
      <div class="col-24">

        <!-- -->
        <div class="sts-object">

          <div class="sts-label-row">
            <input type="radio"
                   class="sts-radio-button"
                   formControlName="mode"
                   value="email"
                   *ngIf="canPickUsernameToo"
                   id="sts-pick-login-email"
                   (change)="onSignupModeChanged($event)">
            <label app-sts-cms-txt key="sts-pick-login-email" for="sts-pick-login-email">
              Personal email address:
            </label>
          </div>
          <div class="sts-input-row">
            <input type="text"
                   [attr.disabled]="emailOnFileReadOnly || (canPickUsernameToo && signUpForm.controls['mode'].value == 'username') ? '' : null"
                   name="sts_pick_email"
                   formControlName="emailInput"
                   maxlength="100"
                   [ngClass]="{'has-errors' : !signUpForm.controls['emailInput'].valid }"
                   class="sts-textbox" >
            <div class="text-danger" *ngIf="signUpForm.controls['emailInput'].invalid">
              <div app-sts-cms-txt key="sts-email-is-unique-required" *ngIf="signUpForm.controls['emailInput'].errors['emailRequired']">An email is required</div>
              <div app-sts-cms-txt key="sts-email-is-valid-required" *ngIf="signUpForm.controls['emailInput'].errors['validateEmail']">A valid email is required</div>
            </div>
          </div>

          <div *ngIf="canPickUsernameToo">
            <div class="sts-label-row">
              <input type="radio"
                    class="sts-radio-button"
                    formControlName="mode"
                    value="username"
                    id="sts-pick-login-username"
                    (change)="onSignupModeChanged($event)">
              <label *ngIf="!changeUserId" app-sts-cms-txt key="sts-pick-login-username" for="sts-pick-login-username">
                enter a Unique User ID:
              </label>
              <label *ngIf="changeUserId" app-sts-cms-txt key="sts-change-login-username" for="sts-pick-login-username">
                enter a Unique User ID:
              </label>
            </div>
            <div class="sts-input-row">
              <input type="text"
                    app-sts-async-validator
                    app-sts-username-email-validator
                    [mode]="signUpForm.controls['mode']"
                    [modeDelegate]="getMode"
                    [attr.disabled]="signUpForm.controls['mode'].value == 'email' ? '' : null"
                    formControlName="usernameInput"
                    [ngClass]="{'has-errors':!signUpForm.controls['usernameInput'].valid}"
                    name="sts_pick_username"
                    maxlength="100"
                    class="sts-textbox" >
              <div class="text-danger" *ngIf="signUpForm.controls['usernameInput'].invalid">
                <div app-sts-cms-txt key="sts-email-is-required" *ngIf="signUpForm.controls['usernameInput'].errors['usernameRequired']">A username is required</div>
              </div>
            </div>
          </div>

        </div>
        <!-- -->



      </div>
    </div>

    <div class="row">
      <div class="col-24">

        <!-- -->
        <div class="sts-object">
          <button app-sts-cms-txt key="sts-cancel-button"
                  class="sts-btn other-sts-btn"
                  type="button"
                  (click)="gotoHome()">
            Cancel
          </button>
          <app-sts-button [submit]="submitter"
                          key="sts-next-button">
            Next
          </app-sts-button>
        </div>
        <!-- -->

      </div>
    </div>

  </form>


</section>


